const PROFILE = {
    ME: {
        MAIN: ["/mon-profil"],
        ROOT: ["/mon-profil"],
        DATING: ["/mon-profil/rencontre"],
        FRIENDS: ["/mon-profil/amis/:page([0-9]+)?"],
        ARTICLES: ["/mon-profil/articles/:page([0-9]+)?"],
        ARTICLE: ["/mon-profil/:articleSlug([A-Za-z0-9_-]*)_:articleId?"],
        ALBUMS: ["/mon-profil/albums/:page([0-9]+)?"],
        ALBUM: ["/mon-profil/albums/:albumSlug([A-Za-z0-9_-]*)_:albumId/:page([0-9]+)?"],
        STATUS: ["/mon-profil/status/:statusId([0-9a-fA-F]{24})"],
        NOTIFICATIONSTATUR: ["/mon-profil/notification/:notificationId([0-9a-fA-F]{24})"],
        MEDIAS: ["/mon-profil/medias/:page([0-9]+)?"],
    },
    USER: {
        MAIN: [
            "/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug",
            "/blog-sexe-amateur/:userSlug",
            "/exhibition-sexe/:userSlug"
        ],
        ROOT: ["/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug"],
        DATING: ["/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug/rencontre"],
        FRIENDS: ["/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug/amis/:page([0-9]+)?"],
        ARTICLES: [
            "/blog-sexe-amateur/:userSlug/:page([0-9]+)?",
            "/blog-sexe-amateur/:userSlug/:blogSlug([A-Za-z0-9_-]+)/:page([0-9]+)?"
        ],
        ARTICLE: ["/blog-sexe-amateur/:userSlug/:articleSlug([A-Za-z0-9_-]*)_:articleId?"],
        ALBUMS: ["/exhibition-sexe/:userSlug/:page([0-9]+)?"],
        ALBUM: ["/exhibition-sexe/:userSlug/:albumSlug([A-Za-z0-9_-]*)_:albumId/:page([0-9]+)?"],
        STATUS: ["/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug/status/:statusId([0-9a-fA-F]{24})"],
        NOTIFICATIONSTATUR: ["/(amateur-sexe|amatrice-sexe|couple-amateur-sexe|travesti-amateur)/:userSlug/notification/:notificationId([0-9a-fA-F]{24})"],
        MEDIAS: ["/exhibition-sexe/:userSlug/medias/:page([0-9]+)?"],
    }
}

const PROFILE_MIXED = {
    MAIN: [...PROFILE.ME.MAIN, ...PROFILE.USER.MAIN],
    ROOT: [...PROFILE.ME.ROOT, ...PROFILE.USER.ROOT],
    DATING: [...PROFILE.ME.DATING, ...PROFILE.USER.DATING],
    FRIENDS: [...PROFILE.ME.FRIENDS, ...PROFILE.USER.FRIENDS],
    ARTICLES: [...PROFILE.ME.ARTICLES, ...PROFILE.USER.ARTICLES],
    ARTICLE: [...PROFILE.ME.ARTICLE, ...PROFILE.USER.ARTICLE],
    ALBUMS: [...PROFILE.ME.ALBUMS, ...PROFILE.USER.ALBUMS],
    ALBUM: [...PROFILE.ME.ALBUM, ...PROFILE.USER.ALBUM],
    STATUS: [...PROFILE.ME.STATUS, ...PROFILE.USER.STATUS],
    NOTIFICATIONSTATUR: [...PROFILE.ME.NOTIFICATIONSTATUR, ...PROFILE.USER.NOTIFICATIONSTATUR],
    MEDIAS: [...PROFILE.ME.MEDIAS, ...PROFILE.USER.MEDIAS],
}

export default {
    PROFILE_MIXED,
    PROFILE
}